{
  "title": "How to Upload Submission Files and Mark Ready",
  "description": "Upload the files your submission needs, then mark it \"Ready\" so it can be formally submitted.",
  "headings": [
    "What You'll Accomplish",
    "Applies To",
    "Before You Start",
    "Steps",
    "What You'll See",
    "FAQ"
  ],
  "summary": "When you're done, your submission's files are uploaded, its status is \"Ready\", and it can now be formally submitted.",
  "roleNote": "Student",
  "prerequisites": [
    "A submission has already been created (category + round chosen)",
    "You've joined a team"
  ],
  "pathLabel": "Team Workspace → My Submission",
  "steps": [
    {
      "title": "1. Choose which field to upload to",
      "description": "Each file-type field on the submission form has its own allowed file types and size limit; whether a field is required is set by the organizer."
    },
    {
      "title": "2. Upload the file",
      "description": "Pick a file and it uploads directly; the per-file limit is 500 MB, and anything over 100 MB automatically switches to multipart upload behind the scenes — the process is transparent to you. Uploads are checked against the field's extension/type and size rules, and a mismatch is flagged immediately."
    },
    {
      "title": "3. Confirm the file is listed",
      "description": "Once uploaded, the file appears in that field's file list; you can delete and re-upload it if needed. You can keep adding or replacing files in both \"Draft\" and \"Ready\" status — marking ready does not lock your files. If an upload genuinely fails partway through (not merely never attempted), the field shows a distinct \"Upload failed, please retry\" status instead of just looking incomplete; pick the file again and re-upload."
    },
    {
      "title": "4. Mark it ready",
      "description": "Once every required field (files and regular fields alike) is complete, click \"Mark Ready\" to move the submission from \"Draft\" to \"Ready\"; you can also click \"Back to Draft\" at any time to return to an editable state."
    }
  ],
  "afterward": [
    "The submission shows status \"Ready\"",
    "You can still upload, delete files, or edit regular fields while in \"Ready\" status",
    "You can switch back and forth between \"Draft\" and \"Ready\" any time before the deadline"
  ],
  "nextSteps": "Once you've confirmed everything is correct, see \"How to Formally Submit Your Work\" to complete the final submission (after that, no further edits or uploads are possible).",
  "faq": [
    {
      "q": "Can I still edit content or re-upload files after marking ready?",
      "a": "Yes. Both \"Ready\" and \"Draft\" are editable states — \"Ready\" just means you consider it done and ready for formal submission. Only the formal \"Submit\" action actually locks it, after which no further edits are possible."
    },
    {
      "q": "Why might a file upload fail?",
      "a": "The most common reasons are: the file type doesn't match what that field allows, the file exceeds the 500 MB limit, or the submission deadline has already passed (uploads are blocked after the deadline). Check the on-screen error message for specifics. The deadline is the current round's submission deadline."
    },
    {
      "q": "Do I have to mark ready before I can formally submit?",
      "a": "Yes. A submission must be in \"Ready\" status before it can be formally submitted; the system blocks the formal submit action while it's still in \"Draft\"."
    },
    {
      "q": "Can I upload my work before registration closes?",
      "a": "Yes, as long as the organizer's submission window has started. Registration and submission times may overlap; during the overlap the competition status reads \"Registration open\", but teams that have finished registration and team setup can still start or continue preparing their work. The actual submission deadline is the date shown on the competition page and the submission page."
    }
  ]
}
